// import axios from '../../helpers/axios';
import {loginPending,loginSuccess,loginFailed,signupSuccess,signupPending,stopLoading,signupFailed,logoutPending,logoutSuccess} from '../reducers/auth.slice';
import { db, fb, auth, static_img } from '../../config/firebase';
import { fetchProfile } from './profile.action';
import { clearProfile } from 'src/redux/reducers/profile.slice';
import { clearUser } from 'src/redux/reducers/user.slice';
import { clearChat } from 'src/redux/reducers/chat.slice';
import { clearCompany } from 'src/redux/reducers/company.slice';
// import { clearSlice } from '../reducers/transaction.slice';
// import { clearBank } from '../reducers/bank.slice';
// import { createBankAcc } from './bank.action';

import { SESClient, SendEmailCommand } from "@aws-sdk/client-ses";
import axios from 'axios';





// export const signup = (user, history) => async (dispatch) => {
//   //console.log(user);
//    dispatch(signupPending());
//    const res = db.collection('users').add({
//         name: user.name,
//         email: user.email,
//         password: user.password,
//     })
//     .then((docRef) => {
//         //console.log("Document written with ID: ", docRef.id);
//         //console.log('Response is: ', res);
//         dispatch(signupSuccess());
//         history.push("/login");
//     })
//     .catch((err) => {
//         console.error("Error adding document: ", err);
//         dispatch(signupFailed({err, msg}));
//     });
//   }



export const signup = (user, history, notifySkip, options = {}) => async (dispatch) => {
      //console.log(user);
       dispatch(signupPending());
       setTimeout( ()=>{dispatch(stopLoading())},1500  );


const sesClient = new SESClient({
  region: "eu-north-1", // e.g. "us-east-1" - come and remove these environemt variables before pushing o !
  credentials: {
    accessKeyId:process.env.REACT_APP_ACCESSKEYID_NURTURER,
    secretAccessKey:process.env.REACT_APP_SECRETACCESSKEY_NURTURER,
  },
});

   

       db.collection('companies')
            .get()
            .then((snapshot) => {
              
          
              const  validCompanyIds = snapshot.docs.map((doc) => (doc.data().companyID));

    
              //console.log("WHAT IS VALID COMPANY IDS--->",validCompanyIds)
              //console.log("WHAT IS COMPANY ID SUBMITTED FOR USER--->",user.companyID)
              
       if(validCompanyIds.includes(user.companyID)){  
        fb.auth().createUserWithEmailAndPassword(
          user.email,
          user.password
      ).then(async(res)=>{

      /**TRY TO SEND THE EMAIL HERE - START */

       db.collection('users').doc(res.user.uid).set({
        uid: res.user.uid,
        name: user.name,
        email: user.email,
        companyID:user.companyID,
        workspaceRole: user.workspaceRole || 'MEMBER',
        phone: user.phone,
        password: user.password,
        photoUrl: static_img,
        lastActive: new Date().getTime(),
       queryMsg:[
         {
          firstParagraph:"I hope you're doing well and navigating this season with clarity. It’s been about three months since we last connected, and I’ve been thinking about your role at Code Forge Labs—especially given how fast backend technologies and infrastructure tools are evolving. With performance optimization and scalable architecture top of mind for so many teams, your work is likely more impactful than ever.",
           secondParagraph:"While reading through some recent industry updates, I came across a couple of articles that I thought you might enjoy. They touch on themes related to backend efficiency, database design, and evolving best practices in engineering teams",
          thirdParagraph:"We had some great conversations previously, and I really appreciated hearing how you approach clean architecture and performance at scale. Let me know if you’re up for a quick catch-up sometime soon—I’d love to hear what you’ve been building (and maybe even what your latest keyboard mod looks like). Wishing you continued momentum",
          messageType:"Touches",
          bulletPoints:[
            {          
          bulletPointBold:"Deloitte Global's 2025 Airline CEO Survey",
          bulletPointRest:"Deloitte, May 30, 2025 Deloitte Link",
          id:"7",
          link:" "
            },
            {
              bulletPointBold:"A breath of fresh air for the national aviation industry",
              bulletPointRest:"PwC, June 3, 2025 PwC Link",
               id:"8",
               link:""
            }
          ]
         },
         {
          firstParagraph:"Wishing you a very happy birthday and a great year ahead!",
           secondParagraph:"Hope today brings some well-deserved time to relax and enjoy yourself.",
          thirdParagraph:"Here’s to continued success and many great moments ahead!",
          messageType:"Birthday",
          bulletPoints:[
            {          
          bulletPointBold:"Deloitte Global's 2025 Airline CEO Survey",
          bulletPointRest:"Deloitte, May 30, 2025 Deloitte Link",
          id:"7",
          link:" "
            },
            {
              bulletPointBold:"A breath of fresh air for the national aviation industry",
              bulletPointRest:"PwC, June 3, 2025 PwC Link",
               id:"8",
               link:""
            }
          ]
         },
         {
          firstParagraph:"Hope you’re enjoying your New Year's holiday and getting some time to recharge.",
           secondParagraph:"Wishing you a joyful day filled with good moments and great company.",
          thirdParagraph:"All the best to you this holiday season!",
          messageType:"Holiday",
          bulletPoints:[
            {          
          bulletPointBold:"",
          bulletPointRest:" ",
          id:"7",
          link:" "
            },
            {
              bulletPointBold:" ",
              bulletPointRest:" ",
               id:"8",
               link:""
            }
          ]
         }
         

       ],
        registeredOn:new Date()
      })

      if (options.inviteRefPath) {
        try {
          await db.doc(options.inviteRefPath).update({
            status: 'ACCEPTED',
            acceptedAt: new Date(),
          });
        } catch (inviteError) {
          console.error('Could not mark team invite accepted after signup', inviteError);
        }
      }
      
      try {
        const params = {
          Destination: {
            ToAddresses: [user.email], // recipient email
          },
          Message: {
            Body: {
              Text: {
                Data: "Welcome to Nurturer – Your Account is Ready.",
              },
              Html: {
                Data: ` <h2>Welcome to Nurturer!</h2>
                       <p>${user.name &&user.name||user.name &&user.name},</p>
                       <br/>
                       <br/>

                       
                       <p>Welcome aboard! Your registration on Nurturer is now complete, and you’re all set to begin using the platform.</p>
                       <br/>


                        <p>With Nurturer, you’ll have the tools to stay connected with your leads, nurture stronger relationships, and remain top of mind in a simple, effective way. Your access has already been set up, so you can dive right in and start making the most of the platform.</p>
                        <br/>
                        <p>We’re excited to have you join the Nurturer community and look forward to supporting your success.</p>
                        <br/>
    
                       
    
                        <p>Warm Regards</p>,
                        <p>– The Nurturer Team</p>`
              },
            },
            Subject: {
              Data: "Welcome to Nurturer – Your Account is Ready",
            },
          }, 
          Source: 'info@nurturer.ai'//process.env.SES_FROM_EMAIL, // must be a verified SES sender
        };

    
       // const command = new SendEmailCommand(params); we arent using SES
       // const response = await sesClient.send(command);
    
        //console.log("✅ Email sent successfully:", response.MessageId);
       // return response;

       const emailHTML = 
        ` <h2>Welcome to Nurturer!</h2>
               <p>${user.name &&user.name||user.name &&user.name},</p>
               <br/>
               <br/>

               
               <p>Welcome aboard! Your registration on Nurturer is now complete, and you’re all set to begin using the platform.</p>
               <br/>


                <p>With Nurturer, you’ll have the tools to stay connected with your leads, nurture stronger relationships, and remain top of mind in a simple, effective way. Your access has already been set up, so you can dive right in and start making the most of the platform.</p>
                <br/>
                <p>We’re excited to have you join the Nurturer community and look forward to supporting your success.</p>
                <br/>

               

                <p>Warm Regards,</p>
                <p>The Nurturer Team</p>`
      


       const response = await axios.post(
        /*"http://localhost:5008/send-email",*/
    "https://nurturer-sendgrid-backend.vercel.app/send-email",
    /* "https://nurturer-sendgrid-backend-production.up.railway.app/send-email",*/
   {
     to: user.email && user.email, // or 'devs@nurturer.ai'
     subject: "Welcome to Nurturer",
     htmlMessage: emailHTML,
     name:user.name && user.name,
     userEmail:'info@nurturer.ai'
   },
   {
     headers: {
       "Content-Type": "application/json",
     },
   }
  )

  console.log("RESPONSE IS=====>",response)

  const result = await response.data; // <-- parse backend JSON


   
      } catch (error) {
        console.error("❌ Error sending email:", error);
        throw error;
      }



     /**TRY TO SEND THE EMAIL HERE - END */

    
      }).then(() => {
        dispatch(signupSuccess());




        history.push("/login");
      }).catch((err) => {
        console.error("Error signiing up: ", err);
        var errorMessage = err.message;
        dispatch(signupFailed({ errorMessage }));
      })

      }else{
        notifySkip("The company ID you entered is invalid, please verify your company ID and try again!")
      }




      })    



  }

  export const signin = (user, history, options = {}) => async (dispatch) => {
    dispatch(loginPending());

    if (!fb || !auth || !db) {
      dispatch(loginFailed({
        errorMessage: 'Authentication is not configured. Please contact support.',
      }));
      return;
    }

    try {
      const userCredential = await auth.signInWithEmailAndPassword(user.email, user.password);
      const firebaseUser = userCredential.user;
      const uid = firebaseUser.uid;

      let profile = {
        uid,
        email: firebaseUser.email || user.email,
        name: firebaseUser.displayName || '',
      };

      try {
        const doc = await db.collection('users').doc(uid).get();
        if (doc.exists) {
          profile = { ...profile, ...doc.data(), uid };
        }
      } catch (profileError) {
        console.warn('Could not load Firestore profile; using Firebase auth user.', profileError);
      }

      if (options.inviteToken && options.companyID) {
        const { acceptTeamInviteForExistingUser } = await import('./company.action');
        const accepted = await dispatch(
          acceptTeamInviteForExistingUser(
            { companyID: options.companyID, inviteToken: options.inviteToken },
            profile
          )
        );
        if (!accepted?.ok) {
          await auth.signOut();
          dispatch(loginFailed({
            errorMessage: accepted?.error || 'Could not accept team invite.',
          }));
          return;
        }
        const refreshed = await db.collection('users').doc(uid).get();
        if (refreshed.exists) {
          profile = { ...profile, ...refreshed.data(), uid };
        }
      }

      dispatch(loginSuccess({ user: profile, uid }));
      dispatch(fetchProfile());
      dispatch(updateLastActive(uid));
      history.push('/apps/dashboard');
    } catch (error) {
      console.error('Sign in failed:', error);
      dispatch(loginFailed({ errorMessage: 'Invalid login credentials' }));
    }
  };


export const sendPasswordReset = (email) => async (dispatch) => {
  dispatch(loginPending());

  if (!auth) {
    dispatch(loginFailed({ errorMessage: 'Authentication is not configured. Please contact support.' }));
    return { success: false };
  }

  try {
    await auth.sendPasswordResetEmail(email);
    dispatch(stopLoading());
    return { success: true };
  } catch (error) {
    let errorMessage = error.message || 'Unable to send reset email.';

    if (error.code === 'auth/user-not-found') {
      errorMessage = 'No account found with that email address.';
    }

    dispatch(loginFailed({ errorMessage }));
    return { success: false };
  }
};

export const logout = (history) => async (dispatch) => {
  const currentUser = fb.auth().currentUser;
  // console.log('Logging out currentUser=======>>>>>>> ', currentUser);

  if (currentUser?.uid) {
    dispatch(updateLastActive(currentUser.uid));
  }

  fb.auth().signOut().then(() => {
    //console.log('logout successful!');
    dispatch(clearProfile());
    dispatch(clearUser());
    dispatch(clearChat());
    dispatch(clearCompany());
    dispatch(logoutSuccess());
    history.push('/login');
  }).catch((error) => {
    // An error happened.
    //console.log('logout failed response: ', error.message);
  });
  
}


export const fetchUserData = (uid) => async (dispatch) => {
  const currentUserProfile = db.collection("users").doc(uid);
  
      currentUserProfile.get()
      .then((doc) => {
          const user = doc.data();
          //console.log(user)
          dispatch(loginSuccess({ user }));
      })
}


export const updateLastActive = (uid) => async (dispatch) => {
  const currentTimeStamp = new Date().getTime();
  var userRef = db.collection("users").doc(uid);
   userRef.update({
      lastActive: currentTimeStamp,
  })
  .then(() => {
    //console.log('Timestamp updated');
  })
  .catch((error) => {
    var errorMessage = error.message;
    //console.log('Error updating timestamp:', errorMessage);
  });
}
